import ClickableTableCell from 'Components/ClickableTableCell'
import type { HeadCell } from 'Components/EnhancedTableHead/EnhancedTableHead'
import StyledTableRow from 'Components/StyledTableRow'
import { WithLoader } from 'Components/WithLoader'
import type { ParameterGroupParameter } from 'Services/ProductManagement/Features/Parameter/types'
import { ROWS_PER_PAGE_DEFAULT } from 'Util/constants'
import { showValueOrHyphen } from 'Util/formatters'
import getTranslation from 'Util/getTranslation'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'
import { t } from 'ttag'

interface ParameterGroupListProps {
  rows: ParameterGroupParameter[]
  isLoading: boolean
  onRowClick: (id: string) => void
}

function ParameterGroupList({ rows, isLoading, onRowClick }: Readonly<ParameterGroupListProps>) {
  const headCells: HeadCell[] = [
    {
      id: 'parameterId',
      numeric: false,
      disablePadding: false,
      label: t`Identifier`,
      sortable: true
    },
    {
      id: 'name',
      numeric: false,
      disablePadding: false,
      label: t`Name`,
      sortable: true
    }
  ]

  return (
    <WithLoader loading={isLoading} rows={ROWS_PER_PAGE_DEFAULT} height={33}>
      <Paper sx={{ width: '100%' }}>
        <TableContainer>
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size="small">
            <TableHead>
              <TableRow>
                {headCells.map(cell => (
                  <TableCell key={cell.id}>{cell.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map(row => {
                return (
                  <StyledTableRow hover tabIndex={-1} key={row.parameter_id}>
                    <ClickableTableCell onClick={() => onRowClick(row.parameter_id)}>
                      {showValueOrHyphen(row.parameter_id)}
                    </ClickableTableCell>
                    <ClickableTableCell onClick={() => onRowClick(row.parameter_id)}>
                      {getTranslation(row.translations, 'fi').value}
                    </ClickableTableCell>
                  </StyledTableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </WithLoader>
  )
}

export default ParameterGroupList
